<router-outlet (activate)="onActivateRoute()"></router-outlet>

<simple-notifications></simple-notifications>
